import React from "react";
import { Route, Routes as ReactRoutes } from "react-router-dom";
import { CanAccessThisPage } from "Common/RoleVerify";


import useFetchMenu from "Common/FetchAllMenu";
import FloorList from "Partials/RoomsSettings/Floor/FloorList/FloorList";
import PositionsList from "HRMS/Positions/PositionsList/PositionsList";
import DepartmentList from "HRMS/Department/DepartmentList/DepartmentList";
import DivisionList from "HRMS/Division/DivisionList/DivisionList";
import RecruitmentList from "HRMS/Recruitment/CandidateRecruitment/RecruitmentList/RecruitmentList";
import CandidateShortlistList from "HRMS/Recruitment/CandidateShortlist/CandidateShortlistList/CandidateShortlistList";
import CandidateInterviewList from "HRMS/Recruitment/CandidateInterview/CandidateInterviewList/CandidateInterviewList";
import CandidateSelectionList from "HRMS/Recruitment/CandidateSelection/CandidateSelectionList/CandidateSelectionList";
import ManageWeekHolidays from "HRMS/Leave/WeeklyHoliday/ManageWeekHolidays/ManageWeekHolidays";
import HolidayList from "HRMS/Leave/Holiday/HolidayList/HolidayList";
import LeaveTypeList from "HRMS/Leave/LeaveType/LeaveTypeList/LeaveTypeList";
import LeaveApplicationList from "HRMS/Leave/LeaveApplication/LeaveApplicationList/LeaveApplicationList";
import EmployeeList from "HRMS/Employee/EmployeeList/EmployeeList";
import EmployeePerformanceList from "HRMS/EmployeePerformance/EmployeePerformanceList/EmployeePerformanceList";
import AwardList from "HRMS/Award/AwardList/AwardList";
import GrandLoanList from "HRMS/Loan/GrandLoan/GrandLoanList/GrandLoanList";
import LoanInstallmentList from "HRMS/Loan/LoanInstallment/LoanInstallmentList/LoanInstallmentList";
import EmployeeSalaryPaymentList from "HRMS/EmployeeSalaryPayment/EmployeeSalaryPaymentList/EmployeeSalaryPaymentList";
import LoanReportList from "HRMS/Loan/LoanReport/LoanReportList/LoanReportList";
import SalaryTypeList from "HRMS/Payroll/SalaryType/SalaryTypeList/SalaryTypeList";
import SalarySetupList from "HRMS/Payroll/SalarySetup/SalarySetupList/SalarySetupList";
import SalaryGenerateList from "HRMS/Payroll/SalaryGenerate/SalaryGenerateList/SalaryGenerateList";
import AttendanceList from "HRMS/Attendance/AttendanceList/AttendanceList";
import AttendanceReport from "HRMS/AttendanceReport/AttendanceReport";


const hotelComponents = {
  FloorList,
  PositionsList,
  DepartmentList,
  DivisionList,
  RecruitmentList,
  CandidateShortlistList,
  CandidateInterviewList,
  CandidateSelectionList,
  ManageWeekHolidays,
  HolidayList,
  LeaveTypeList,
  LeaveApplicationList,
  EmployeeList,
  EmployeePerformanceList,
  AwardList,
  GrandLoanList,
  LoanInstallmentList,
  EmployeeSalaryPaymentList,
  LoanReportList,
  SalaryTypeList,
  SalarySetupList,
  SalaryGenerateList,
  AttendanceList,
  AttendanceReport,
};

const HotelDynamicRoutes = () => {
  const { menu: hotelMenu } = useFetchMenu("human_resource");

  const SpretMenu = hotelMenu ? hotelMenu.flatMap((item) => item.children || []) : [];

  return SpretMenu.map((item, index) => {
    const Component = hotelComponents[item.component_name];
    if (!Component) {
      return null;
    }
    return (
      <Route
        key={index}
        path={`/${item.page_url}`}
        element={
          <CanAccessThisPage menu_access={['can_access', 'can_create', 'can_edit', 'can_delete']} page_url={item?.page_url}>
            {<Component />}
          </CanAccessThisPage>
        }
      />
    );
  }).filter(Boolean);
};

export default HotelDynamicRoutes;
